import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var MiscService = /** @class */ (function () {
    function MiscService(http) {
        this.http = http;
        this.endpoints = {
            sendEmail: '/dashboard/sendemail'
        };
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    MiscService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    MiscService.prototype.sendEmail = function (templateName) {
        var endPoint = this.endpoints.sendEmail;
        var params = {
            'mail_template': templateName,
            'mail_template_params': {}
        };
        return this.http.post(endPoint, params, this.httpOptions).pipe(map(this.extractData));
    };
    MiscService.ngInjectableDef = i0.defineInjectable({ factory: function MiscService_Factory() { return new MiscService(i0.inject(i1.HttpClient)); }, token: MiscService, providedIn: "root" });
    return MiscService;
}());
export { MiscService };
